export const partnerTableHeaders = [
  {
    Header: "S.No",
    accessor: "id",
  },
  {
    Header: "Name",
    accessor: "Name",
  },
  {
    Header: "User Name",
    accessor: "UserName",
  },
  {
    Header: "Email",
    accessor: "Email",
  },
  {
    Header: "Mobile Number",
    accessor: "MobileNumber",
  },
  {
    Header: "Status",
    accessor: "IsActive",
  },
  {
    Header: "Actions",
    accessor: "actions",
    disableSortBy: true,
  },
];
